var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('el-container',{staticClass:"container"},[_c('Sidebar',{ref:"side"}),_c('el-container',[_c('el-header',{staticClass:"header"},[_c('div',[_c('Top',{on:{"getThemes":_vm.getThemes}})],1)]),_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }